import { useEffect } from 'react';

/**
 * @param {Object} ref
 * @param {Function} onClickingHandler
 */
const useClickOutsideHandler = (ref, onClickingHandler) => {
  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickingHandler();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickingHandler]);
};

export default useClickOutsideHandler;
